// import { useState } from "react";
// import { useNavigate, Link } from "react-router-dom";
// import axios from "axios";
// import { Box, Typography, TextField, Button, } from "@mui/material";
// import MailOutlineIcon from "@mui/icons-material/MailOutline";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";
// import CopyrightIcon from "@mui/icons-material/Copyright";
// import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";

// function ForgotPassword({ connectionString }) {
//   const path = connectionString;
//   const navigate = useNavigate();

//   const [email, setEmail] = useState("");
//   const [message, setMessage] = useState("");
//   const [error, setError] = useState("");
//   const [otpSent, setOtpSent] = useState(false);
//   const [loading, setLoading] = useState(false);

//   const FN_HandleSendOTP = async (e) => {
//     e.preventDefault();
//     setMessage("");
//     setError("");

//     if (!email) {
//       setError("Please enter your registered email.");
//       return;
//     }

//     try {
//       setLoading(true);
//       const response = await axios.post(`${path}/api/forgot-password`, { email });

//       if (response.data.success) {
//         setMessage("Password reset instructions have been sent to your email.");
//         setOtpSent(true);
//       } else {
//         setError(response.data.message || "Failed to send email.");
//       }
//     } catch (err) {
//       console.error(err);
//       setError("Something went wrong. Please try again later.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Box sx={{ minHeight: "100vh", display: "flex" }}>
//       {/* LEFT SIDE – SAME AS LOGIN */}
//       <Box sx={{ display: { xs: "none", lg: "flex" }, width: "65%", position: "relative", overflow: "hidden", background: "linear-gradient(135deg, #dbeafe, #e9d5ff, #fce7f3)", }} >
//         {/* Animated Orbs */}
//         <Box sx={{ position: "absolute", inset: 0 }}>
//           <Box sx={{ position: "absolute", top: 0, left: 0, width: 384, height: 384, bgcolor: "#93c5fd", borderRadius: "50%", filter: "blur(64px)", opacity: 0.4, animation: "blob 7s infinite" }} />
//           <Box sx={{ position: "absolute", top: 0, right: 0, width: 384, height: 384, bgcolor: "#c4b5fd", borderRadius: "50%", filter: "blur(64px)", opacity: 0.4, animation: "blob 7s infinite 2s" }} />
//           <Box sx={{ position: "absolute", bottom: 0, left: "50%", width: 384, height: 384, bgcolor: "#f9a8d4", borderRadius: "50%", filter: "blur(64px)", opacity: 0.4, animation: "blob 7s infinite 4s" }} />
//         </Box>

//         {/* Grid */}
//         <Box sx={{ position: "absolute", inset: 0, opacity: 0.1, backgroundSize: "60px 60px", backgroundImage: ` linear-gradient(rgba(0,0,0,0.05) 1px, transparent 1px), linear-gradient(90deg, rgba(0,0,0,0.05) 1px, transparent 1px) `, }} />

//         {/* Center Content */}
//         <Box sx={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", textAlign: "center", maxWidth: 520, px: 4, }} >
//           <Typography sx={{ fontSize: 44, fontWeight: 700, color: "#111827", mb: 2 }}>
//             Forgot your password?
//           </Typography>
//           <Typography sx={{ fontSize: 18, color: "#4b5563" }}>
//             No worries. We'll help you get back into your account safely.
//           </Typography>
//         </Box>

//         <style>{`
//           @keyframes blob {
//             0%, 100% { transform: translate(0,0) scale(1); }
//             25% { transform: translate(20px,-40px) scale(1.05); }
//             50% { transform: translate(-20px,20px) scale(0.95); }
//             75% { transform: translate(40px,40px) scale(1.05); }
//           }
//         `}</style>
//       </Box>

//       {/* RIGHT SIDE – FORM */}
//       <Box sx={{ width: { xs: "100%", lg: "35%" }, display: "flex", alignItems: "center", justifyContent: "center", p: 4, bgcolor: "#ffffff", position: "relative", }} >
//         <Box sx={{ width: "100%", maxWidth: 420 }}>
//           {/* Back Arrow – visible only before OTP is sent */}
//           {!otpSent && (
//             <Box sx={{ mb: 2 }}>
//               <Button startIcon={<ArrowBackIosNewIcon />} onClick={() => navigate("/ReonBook")} sx={{ textTransform: "none", fontWeight: 600, color: "#3b82f6", px: 0, "&:hover": { background: "transparent", color: "#1d4ed8", }, }} >
//                 Back
//               </Button>
//             </Box>
//           )}
//           {/* Logo */}
//           <Box sx={{ mb: 6 }}>
//             <Box component="img" src="/Nexon_CRM_Final.svg" alt="Nexon CRM" sx={{ height: 40 }} />
//           </Box>

//           {/* Heading */}
//           <Typography variant="h4" fontWeight={700} sx={{ color: "#111827", mb: 1 }}>
//             Reset Password
//           </Typography>
//           <Typography sx={{ color: "#6b7280", mb: 4 }}>
//             Enter your registered email to receive reset instructions
//           </Typography>

//           {/* Form */}
//           <Box component="form" onSubmit={FN_HandleSendOTP}>
//             <TextField fullWidth label="Registered Email" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
//               sx={{ mb: 3, "& .MuiOutlinedInput-root": { borderRadius: 3, bgcolor: "#f9fafb", }, }}
//               InputProps={{
//                 startAdornment: <MailOutlineIcon sx={{ mr: 1, color: "#64748b" }} />,
//               }}
//             />

//             {error && (
//               <Box sx={{ bgcolor: "#fef2f2", border: "1px solid #fecaca", color: "#dc2626", p: 1.5, borderRadius: 3, mb: 3 }}>
//                 {error}
//               </Box>
//             )}

//             {message && (
//               <Box sx={{ bgcolor: "#ecfdf5", border: "1px solid #a7f3d0", color: "#047857", p: 1.5, borderRadius: 3, mb: 3, display: "flex", alignItems: "center", gap: 1 }}>
//                 <CheckCircleIcon />
//                 {message}
//               </Box>
//             )}

//             {!otpSent ? (
//               <Button type="submit" fullWidth disabled={loading} sx={{ background: "linear-gradient(to right, #3b82f6, #2563eb)", color: "#fff", py: 1.8, borderRadius: 3, fontWeight: 600, textTransform: "none", }} >
//                 {loading ? "Sending..." : "Send Instructions"}
//               </Button>
//             ) : (
//               <Button fullWidth variant="outlined" onClick={() => navigate("/")} sx={{ py: 1.8, borderRadius: 3, fontWeight: 600 }} >
//                 Return to Login
//               </Button>
//             )}
//           </Box>

//           {/* Footer */}
//           <Typography align="center" sx={{ mt: 6, color: "#9ca3af", fontSize: 13 }}>
//             <CopyrightIcon sx={{ fontSize: 14, mr: 0.5 }} />
//             {new Date().getFullYear()} Powered by{" "}
//             <a href="http://soltrack.co.in/" target="_blank" rel="noreferrer" style={{ color: "#111827", fontWeight: 600 }}>
//               Soltrack Technologies Pvt Ltd
//             </a>
//           </Typography>
//         </Box>
//       </Box>
//     </Box>
//   );
// }

// export default ForgotPassword;

import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Box, Typography, TextField, Button, InputAdornment } from "@mui/material";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CopyrightIcon from "@mui/icons-material/Copyright";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import LockResetIcon from "@mui/icons-material/LockReset";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

function ForgotPassword({ connectionString }) {
  const path = connectionString;
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const FN_HandleSendOTP = async (e) => {
    e.preventDefault();
    setMessage("");
    setError("");

    if (!email) {
      setError("Please enter your registered email.");
      return;
    }

    try {
      setLoading(true);
      console.log('Sending forgot password request to:', `${path}/api/forgot-password`);
      const response = await axios.post(`${path}/api/forgot-password`, { email });

      console.log('Response:', response.data);
      if (response.data.success) {
        setMessage("Password reset instructions have been sent to your email.");
        setOtpSent(true);
      } else {
        setError(response.data.message || "Failed to send email.");
      }
    } catch (err) {
      console.error('Full error object:', err);
      console.error('Error message:', err.message);
      console.error('Error response:', err.response?.data);
      console.error('Error status:', err.response?.status);

      if (err.response?.data?.message) {
        setError(err.response.data.message);
      } else if (err.response?.status === 404) {
        setError("Email not found in system.");
      } else if (err.response?.status === 500) {
        setError(`Server error: ${err.response.data?.message || 'Email service failed'}`);
      } else if (err.message === 'Network Error') {
        setError("Network error. Please check your connection.");
      } else {
        setError(err.response?.data?.message || err.message || "Something went wrong. Please try again later.");
      }
    } finally {
      setLoading(false);
    }
  };

  const steps = [
    { num: "1", text: "Enter your registered email address" },
    { num: "2", text: "Receive secure reset instructions" },
    { num: "3", text: "Create a strong new password" },
  ];

  return (
    <Box sx={{ height: "100vh", overflow: "hidden", display: "flex" }}>

      {/* ── LEFT PANEL ── */}
      <Box sx={{
        display: { xs: "none", lg: "flex" },
        width: "58%",
        flexDirection: "column",
        justifyContent: "space-between",
        position: "relative",
        overflow: "hidden",
        background: "linear-gradient(150deg, #071330 0%, #0c2461 45%, #1565c0 100%)",
        p: { lg: "48px 52px", xl: "64px 72px" },
      }}>
        {/* Dot grid */}
        <Box sx={{ position: "absolute", inset: 0, pointerEvents: "none", opacity: 0.06, backgroundImage: "radial-gradient(circle, #fff 1px, transparent 1px)", backgroundSize: "28px 28px" }} />
        {/* Glow top-right */}
        <Box sx={{ position: "absolute", top: "-20%", right: "-10%", width: 520, height: 520, borderRadius: "50%", background: "radial-gradient(circle, rgba(24,119,242,0.35) 0%, transparent 68%)", pointerEvents: "none" }} />
        {/* Glow bottom-left */}
        <Box sx={{ position: "absolute", bottom: "-15%", left: "-15%", width: 460, height: 460, borderRadius: "50%", background: "radial-gradient(circle, rgba(8,85,168,0.4) 0%, transparent 68%)", pointerEvents: "none" }} />

        {/* Logo */}
        <Box sx={{ position: "relative", zIndex: 1 }}>
          <Box component="img" src="/RBLOGOBLUE.svg" alt="ReonBook" sx={{ height: 32, filter: "brightness(0) invert(1)", opacity: 0.92 }} />
        </Box>

        {/* Hero */}
        <Box sx={{ position: "relative", zIndex: 1 }}>
          {/* Lock icon card */}
          <Box sx={{ width: 72, height: 72, borderRadius: 3, bgcolor: "rgba(255,255,255,0.08)", border: "1px solid rgba(255,255,255,0.14)", display: "flex", alignItems: "center", justifyContent: "center", mb: 3.5 }}>
            <LockResetIcon sx={{ fontSize: 36, color: "#60a5fa" }} />
          </Box>

          <Typography sx={{ color: "#60a5fa", fontSize: "0.72rem", fontWeight: 700, letterSpacing: "3px", textTransform: "uppercase", mb: 2.5 }}>
            Secure Account Recovery
          </Typography>
          <Typography sx={{ fontSize: { lg: "2.4rem", xl: "3rem" }, fontWeight: 800, color: "#f0f6ff", lineHeight: 1.15, mb: 2.5 }}>
            Regain Access<br />
            <Box component="span" sx={{ background: "linear-gradient(90deg, #60a5fa 0%, #a5c8ff 100%)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" }}>
              Safely & Quickly
            </Box>
          </Typography>
          <Typography sx={{ color: "rgba(255,255,255,0.55)", fontSize: "0.92rem", lineHeight: 1.85, maxWidth: 420, mb: 4.5 }}>
            Our secure password recovery system verifies your identity before sending reset instructions to your registered email address.
          </Typography>

          <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            {steps.map((item) => (
              <Box key={item.num} sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <Box sx={{ width: 30, height: 30, borderRadius: "50%", bgcolor: "rgba(24,119,242,0.22)", border: "1.5px solid rgba(96,165,250,0.55)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                  <Typography sx={{ color: "#60a5fa", fontSize: "0.75rem", fontWeight: 800 }}>{item.num}</Typography>
                </Box>
                <Typography sx={{ color: "rgba(255,255,255,0.75)", fontSize: "0.87rem" }}>{item.text}</Typography>
              </Box>
            ))}
          </Box>
        </Box>

        {/* Security badge */}
        <Box sx={{ position: "relative", zIndex: 1, bgcolor: "rgba(255,255,255,0.06)", border: "1px solid rgba(255,255,255,0.1)", borderRadius: 2.5, p: 2.5, display: "flex", alignItems: "center", gap: 2 }}>
          <Box sx={{ width: 44, height: 44, borderRadius: 2, bgcolor: "rgba(96,165,250,0.12)", border: "1px solid rgba(96,165,250,0.25)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
            <MailOutlineIcon sx={{ fontSize: 24, color: "#60a5fa" }} />
          </Box>
          <Box>
            <Typography sx={{ color: "#fff", fontWeight: 700, fontSize: "0.88rem", mb: 0.3 }}>End-to-End Encrypted</Typography>
            <Typography sx={{ color: "rgba(255,255,255,0.45)", fontSize: "0.76rem" }}>Reset links expire in 15 minutes for your security</Typography>
          </Box>
        </Box>
      </Box>

      {/* ── RIGHT PANEL ── */}
      <Box sx={{
        width: { xs: "100%", lg: "42%" },
        height: "100vh",
        overflowY: "auto",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: { xs: 3, sm: 5, md: 6 },
        bgcolor: "#ffffff",
        position: "relative",
      }}>
        <Box sx={{ position: "absolute", inset: 0, pointerEvents: "none", background: "radial-gradient(ellipse at 80% 10%, rgba(24,119,242,0.04) 0%, transparent 50%), radial-gradient(ellipse at 20% 90%, rgba(10,102,194,0.04) 0%, transparent 50%)" }} />

        <Box sx={{ width: "100%", maxWidth: 400, position: "relative", zIndex: 1 }}>

          {/* Back button */}
          {!otpSent && (
            <Button startIcon={<ArrowBackIosNewIcon sx={{ fontSize: "0.9rem !important" }} />}
              onClick={() => navigate("/")}
              sx={{ textTransform: "none", fontWeight: 600, color: "#1877F2", px: 0, mb: 2.5, minWidth: 0, "&:hover": { background: "transparent", color: "#0A66C2" } }}>
              Back to Login
            </Button>
          )}

          {/* Logo — only on mobile/tablet where left panel is hidden */}
          <Box sx={{ display: { xs: "flex", lg: "none" }, justifyContent: "center", mb: 4 }}>
            <Box component="img" src="/RBLOGOBLUE.svg" alt="ReonBook" sx={{ height: 40 }} />
          </Box>

          {!otpSent ? (

            /* ── EMAIL FORM ── */
            <Box>
              <Box sx={{ mb: 4 }}>
                <Typography variant="h4" fontWeight={800} sx={{ color: "#0f172a", fontSize: { xs: "1.6rem", sm: "1.9rem" }, mb: 1, letterSpacing: "-0.5px" }}>
                  Reset Password
                </Typography>
                <Typography sx={{ color: "#64748b", fontSize: "0.9rem" }}>
                  Enter your registered email to receive reset instructions
                </Typography>
              </Box>

              <Box component="form" onSubmit={FN_HandleSendOTP}>
                <TextField fullWidth label="Registered Email" type="email" value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  sx={{
                    mb: 2.5,
                    "& .MuiOutlinedInput-root": {
                      borderRadius: 2, bgcolor: "#f8faff", height: 52,
                      "& input": { padding: "0 14px" },
                      "& fieldset": { borderColor: "#e2e8f0" },
                      "&:hover fieldset": { borderColor: "#1877F2" },
                      "&.Mui-focused fieldset": { borderColor: "#1877F2", borderWidth: 2 },
                    },
                    "& .MuiInputLabel-root.Mui-focused": { color: "#1877F2" },
                  }}
                  InputProps={{ startAdornment: <InputAdornment position="start"><MailOutlineIcon sx={{ color: "#94a3b8", fontSize: 20 }} /></InputAdornment> }}
                />

                {error && (
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1, bgcolor: "#fef2f2", border: "1px solid #fecaca", color: "#dc2626", p: "12px 14px", borderRadius: 2, mb: 2.5, fontSize: "0.83rem" }}>
                    <WarningAmberIcon sx={{ fontSize: 17, flexShrink: 0 }} />
                    {error}
                  </Box>
                )}

                <Button type="submit" fullWidth disabled={loading}
                  sx={{
                    py: 1.6, borderRadius: 2, fontSize: "0.95rem", fontWeight: 700, textTransform: "none",
                    background: "linear-gradient(135deg, #1877F2 0%, #0A66C2 100%)",
                    boxShadow: "0 4px 16px rgba(24,119,242,0.3)",
                    color: "#fff",
                    "&:hover": { background: "linear-gradient(135deg, #0A66C2 0%, #0855A8 100%)", boxShadow: "0 6px 20px rgba(24,119,242,0.4)" },
                    "&.Mui-disabled": { color: "#fff", background: "#93c5fd" },
                  }}>
                  {loading ? "Sending..." : "Send Reset Instructions"}
                </Button>
              </Box>
            </Box>

          ) : (

            /* ── SUCCESS STATE ── */
            <Box sx={{ textAlign: "center", py: 2 }}>
              <Box sx={{ width: 84, height: 84, borderRadius: "50%", bgcolor: "#ecfdf5", border: "2px solid #a7f3d0", display: "flex", alignItems: "center", justifyContent: "center", mx: "auto", mb: 3.5 }}>
                <CheckCircleIcon sx={{ fontSize: 46, color: "#059669" }} />
              </Box>

              <Typography variant="h5" fontWeight={800} sx={{ color: "#0f172a", mb: 1.5, letterSpacing: "-0.5px" }}>
                Instructions Sent!
              </Typography>
              <Typography sx={{ color: "#64748b", fontSize: "0.9rem", lineHeight: 1.75, mb: 3.5 }}>
                We've sent password reset instructions to<br />
                <Box component="span" sx={{ color: "#1877F2", fontWeight: 700 }}>{email}</Box>
              </Typography>

              <Box sx={{ bgcolor: "#f0f9ff", border: "1px solid #bae6fd", borderRadius: 2, p: "14px 18px", mb: 4, textAlign: "left" }}>
                <Typography sx={{ color: "#0369a1", fontSize: "0.82rem", lineHeight: 1.85 }}>
                  • Check your inbox and spam folder<br />
                  • The link expires in <strong>15 minutes</strong><br />
                  • Contact support if you don't receive it
                </Typography>
              </Box>

              <Button fullWidth variant="contained" onClick={() => navigate("/")}
                sx={{
                  py: 1.6, borderRadius: 2, fontSize: "0.95rem", fontWeight: 700, textTransform: "none",
                  background: "linear-gradient(135deg, #1877F2 0%, #0A66C2 100%)",
                  boxShadow: "0 4px 16px rgba(24,119,242,0.3)",
                  "&:hover": { background: "linear-gradient(135deg, #0A66C2 0%, #0855A8 100%)", boxShadow: "0 6px 20px rgba(24,119,242,0.4)" },
                }}>
                Return to Login
              </Button>
            </Box>
          )}

          <Typography align="center" sx={{ mt: 5, color: "#94a3b8", fontSize: "0.73rem" }}>
            <CopyrightIcon sx={{ fontSize: 12, verticalAlign: "middle", mr: 0.4 }} />
            {new Date().getFullYear()} Powered by{" "}
            <a href="http://soltrack.co.in/" target="_blank" rel="noreferrer" style={{ color: "#475569", fontWeight: 600, textDecoration: "none" }}>
              Soltrack Technologies Pvt Ltd
            </a>
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}

export default ForgotPassword;
